module.exports = __webpack_public_path__ + "static/media/cms-logo-login.d5844e1a.svg";